import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ArtistCard = ({artist, className = 'px-2 pb-3'}) => {
    return (
        <div className={className}>
            <div className='artist-card'>
                <div className="position-relative">
                    <span className="avatar-shape"></span>
                    <Link to={`/artist-details/${artist._id}`}>
                        <div className="avatar">
                            <img src={process.env.REACT_APP_BASE_IMAGES_URL+(artist?.imageUrl ? artist?.imageUrl : 'default.png')} />
                        </div>
                    </Link>
                    <Link to={`/artist-details/${artist._id}`}>
                        <div className="overlay"></div>
                    </Link>
                    <span className="poster">
                        <span>
                            <img src={process.env.REACT_APP_BASE_IMAGES_URL+(artist?.imageUrl ? artist?.imageUrl : 'default.png')} />
                        </span>
                    </span>
                </div>
                <Link to={`/artist-details/${artist._id}`}>
                    <h6 className="title">
                        {artist?.artist?.name}
                    </h6>
                    <p className="info">
                        {artist?.artist?.description}
                    </p>
                </Link>
                <hr className="divider" />
                <div className="d-flex justify-content-between py-2">
                    <div className="flex-fill">
                        <p className="info-title">팔로워</p>
                        <p className="info-count">{artist?.totalFavorites ?? 0}</p>
                    </div>
                    <div className="flex-fill">
                        <p className="info-title">포스터</p>
                        <p className="info-count">{artist?.totalPosters ?? 0}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ArtistCard;